import {
  alpha,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  SelectProps,
  styled,
} from "@mui/material";
import React from "react";

const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 14,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.background.default, 0.28)
        : theme.palette.background.paper,
    transition: "background-color 0.2s ease, border-color 0.2s ease",
  },
  "& .MuiSelect-select": {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: 2,
    borderColor: theme.palette.divider,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
  },
  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.divider,
  },
}));

interface CustomSelectProps {
  helperText?: React.ReactNode;
}

const LightSelect: React.FC<CustomSelectProps & SelectProps> = ({
  helperText,
  label,
  labelId,
  error,
  children,
  ...props
}) => {
  return (
    <FormControl fullWidth error={Boolean(error)}>
      {label && <InputLabel id={labelId}>{label}</InputLabel>}
      <StyledSelect labelId={labelId} label={label} error={error} {...props}>
        {children}
      </StyledSelect>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
};

export default LightSelect;
